import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kliki nupul, et kopeerida oma lemmikute lehe link. Jagatud lingil fikseeritakse praegune lemmikute seis.

  <span style="color:#85c1dc;">**FI:**</span>
  Napsauta painiketta kopioidaksesi linkin suosikkeihisi. Nykyinen suosikkitila tallennetaan linkkiin.

  <span style="color:#85c1dc;">**RU:**</span>
  Нажмите кнопку, чтобы скопировать ссылку в избранное. Статус избранного будет сохранен по ссылке.
*/
/* @__NO_SIDE_EFFECTS__ */
const m624 = msg(
  mf`Kliki nupul, et kopeerida oma lemmikute lehe link. Jagatud lingil fikseeritakse praegune lemmikute seis.`,
  mf`Napsauta painiketta kopioidaksesi linkin suosikkeihisi. Nykyinen suosikkitila tallennetaan linkkiin.`,
  mf`Нажмите кнопку, чтобы скопировать ссылку в избранное. Статус избранного будет сохранен по ссылке.`,
)

export { m624 as 'w.wishlist.share.copy.text' }